import React from 'react';
import { Button, InputLabel } from '@material-ui/core';
import { Control, UseFormSetValue, useFieldArray, useWatch } from 'react-hook-form';
import { EditableQuestion, StructuredInputToggle } from '../../../../../types';
import { StyledQuestionFieldContainer } from '../../styles';
import DefaultTogglePicker from './DefaultTogglePicker';
import ToggleBlock from './ToggleBlock';
import { CLEARED_DEFAULT_TOGGLE, createEmptyToggle } from './utils';

interface Props {
  control: Control<EditableQuestion>;
  setValue: UseFormSetValue<EditableQuestion>;
}

const TogglesEditor = ({ control, setValue }: Props) => {
  // keyName is set because toggles carry their own `id`, which the default would shadow.
  const { fields, append, remove } = useFieldArray({ control, name: 'input.toggles', keyName: 'rhfKey' as 'id' });

  const toggles: StructuredInputToggle[] = useWatch({ control, name: 'input.toggles' }) ?? [];
  const defaultToggle: string | undefined = useWatch({ control, name: 'input.default_toggle' });

  // default_toggle names a toggle by id, and the picker hides again below two toggles, so
  // a stale default would be left with no way for the author to correct it.
  const removeToggle = (index: number) => {
    if (defaultToggle && defaultToggle === toggles[index]?.id) {
      setValue('input.default_toggle', CLEARED_DEFAULT_TOGGLE);
    }

    remove(index);
  };

  return (
    <StyledQuestionFieldContainer>
      <InputLabel>Unit toggles</InputLabel>
      {fields.map((field, index) => (
        <ToggleBlock
          key={field.id}
          control={control}
          setValue={setValue}
          index={index}
          onRemove={() => removeToggle(index)}
        />
      ))}
      <Button variant="outlined" color="secondary" onClick={() => append(createEmptyToggle())}>
        Add toggle
      </Button>
      <DefaultTogglePicker control={control} />
    </StyledQuestionFieldContainer>
  );
};

export default TogglesEditor;
